// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import VueI18n from "vue-i18n";
import messages from "./assets/locales/messages";

Vue.use(VueI18n);

Vue.config.productionTip = false;
let locale = navigator.language;
// Declaration
const i18n = new VueI18n({
	locale: locale, // set locale
	fallbackLocale: "fr", // set fallback locale
	messages, // set locale messages
});

/* eslint-disable no-new */
new Vue({
	el: "#app",
	router,
	i18n,
	render: h => h(App),
});
